import styled from 'styled-components';
import { Card as MuiCard, Typography } from '@mui/material';
import Avatar from '@atoms/Avatar';
import { devices } from '../../../../config/devices';

export const Card = styled(MuiCard)`
  max-width: 944px;
  width: 100%;
  padding: 80px;
  display: flex;
  flex-direction: column;
  && {
    border-radius: 16px;
  }
`;

export const CardContianer = styled.div`
  display: flex;
  justify-content: center;
`;

export const OrgAvatar = styled(Avatar)`
  border: 2px solid ${({ theme }) => theme.primary.main};
`;

export const OrgInfo = styled(Typography)`
  color: ${({ theme }) => theme.common.inBlack};
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  svg {
    margin-right: 1.5rem;
  }
`;

export const DetailsContainer = styled.pre`
  margin-top: 2rem;
  white-space: pre-wrap;
  word-wrap: normal;
  word-break: keep-all;
  font-family: 'Source Sans Pro', 'Poppins', 'BlinkMacSystemFont';
  font-size: 16px;
  color: ${({ theme }) => theme.common.inBlack};
`;

export const LinkItem = styled.a`
  color: ${({ theme }) => theme && theme.primary.main};
  && {
    display: flex;
    align-items: center;
    padding-right: 2rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  svg {
    margin-right: 1.5rem;
    color: ${({ theme }) => theme && theme.common.inBlack};
  }
  a {
    display: flex;
    flex-direction: row;
  }
`;
export const LinksContainers = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 1rem;
  margin-bottom: 2rem;
  /* @media (max-width: 959px) { */
  @media ${devices.sm} {
    justify-content: center;
    text-align: center;
    align-items: center;
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
